import { IEditStaticPageRequest } from 'core/model/interfaces/static-pages';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleErrorMessage, showNotificationError } from 'shared/utils/errors.utils';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../constants';
import { IStaticPagesState } from '../types';

export const editStaticPage = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/editStaticPage`,
  async (data: IEditStaticPageRequest) => {
    try {
      await apiService.staticPages.editStaticPage(data);
      notificationService.global.success('La página estática ha sido modificada correctamente.');
    } catch (e) {
      const errorMessage = handleErrorMessage(e, 'Ocurrió un error al editar la página estática.');
      showNotificationError(errorMessage);
      throw e;
    }
  },
);

export const editStaticPageReducer: TSliceExtraReducer<IStaticPagesState> = builder =>
  builder
    .addCase(editStaticPage.pending, state => {
      state.form.loading = true;
      state.form.success = false;
    })
    .addCase(editStaticPage.rejected, state => {
      state.form.loading = false;
      state.form.success = false;
    })
    .addCase(editStaticPage.fulfilled, state => {
      state.form.loading = false;
      state.form.success = true;
    });
